import React, { useEffect, useState } from 'react';
import { Form, FormGroup, FormField, Button, Divider, Accordion, Icon, Container } from 'semantic-ui-react';

const WebToLead = () => {
  const [activeIndex, setActiveIndex] = useState(-1);

  const handleAccordionClick = (e, { index }) => {
    setActiveIndex(activeIndex === index ? -1 : index);
  };

  useEffect(() => {
    // Add meta tags for contact page
    const updateMetaTag = (property, content, isProperty = true) => {
      const attribute = isProperty ? 'property' : 'name';
      let metaTag = document.querySelector(`meta[${attribute}="${property}"]`);
      
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute(attribute, property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', content);
    };

    // Store original title to restore later
    const originalTitle = document.title;

    // Update meta tags for contact page
    document.title = 'Contact Cloud CZR - Professional Salesforce Development & Technology Consulting';
    updateMetaTag('og:title', 'Contact Cloud CZR - Professional Salesforce Development & Technology Consulting');
    updateMetaTag('og:description', 'Contact Cloud CZR for professional Salesforce development and technology consulting services. Reach out via email, phone, or our contact form.');
    updateMetaTag('og:url', window.location.href);
    updateMetaTag('og:type', 'website');
    updateMetaTag('og:image', `${window.location.origin}/assets/CloudChiRho.png`);
    updateMetaTag('og:image:alt', 'Cloud CZR, Cloudczr, cloudczr.com');
    
    updateMetaTag('description', 'Contact Cloud CZR for professional Salesforce development and technology consulting services. Reach out via email, phone, or our contact form.', false);
    updateMetaTag('twitter:title', 'Contact Cloud CZR - Professional Salesforce Development & Technology Consulting', false);
    updateMetaTag('twitter:description', 'Contact Cloud CZR for professional Salesforce development and technology consulting services. Reach out via email, phone, or our contact form.', false);

    // Add reCAPTCHA script
    const script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    // Add timestamp script
    const timestampScript = document.createElement('script');
    timestampScript.innerHTML = `
      function timestamp() {
        var response = document.getElementById("g-recaptcha-response");
        var captchaSettings = document.getElementsByName("captcha_settings")[0];
        if (response == null || response.value.trim() == "") {
          if (captchaSettings) {
            var elems = JSON.parse(captchaSettings.value);
            elems["ts"] = JSON.stringify(new Date().getTime());
            captchaSettings.value = JSON.stringify(elems);
          }
        }
      }
      var intervalId = setInterval(timestamp, 500);
      window.timestampIntervalId = intervalId;
    `;
    document.body.appendChild(timestampScript);

    return () => {
      // Cleanup scripts
      if (script.parentNode) {
        document.body.removeChild(script);
      }
      if (timestampScript.parentNode) {
        document.body.removeChild(timestampScript);
      }
      if (window.timestampIntervalId) {
        clearInterval(window.timestampIntervalId);
      }
      
      // Restore original title
      document.title = originalTitle;
    };
  }, []);

  return (
    <Container style={{ padding: '20px', display: 'flex', flexDirection: 'row', gap: '20px', flexWrap: 'wrap' }}>
      {/* Form Section */}
      <div style={{ flex: '1', minWidth: '300px', maxWidth: '600px' }}>
        <Form
          action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00Dfn00000DYRuL"
          method="POST"
          size="large"
          style={{ backgroundColor: '#a9885c', padding: '20px', borderRadius: '8px' }}
        >
          <input
            type="hidden"
            name="captcha_settings"
            value='{"keyname":"CZ","fallback":"true","orgId":"00Dfn00000DYRuL","ts":""}'
          />
          <input type="hidden" name="oid" value="00Dfn00000DYRuL" />
          <input type="hidden" name="retURL" value="http://cloudcaesar.com" />

          <FormGroup widths="equal">
            <FormField
              label={<label style={{ color: '#702963' }}>First Name</label>}
              control="input"
              id="first_name"
              name="first_name"
              maxLength="40"
              placeholder="First Name"
            />
            <FormField
              label={<label style={{ color: '#702963' }}>Last Name</label>}
              control="input"
              id="last_name"
              name="last_name"
              maxLength="80"
              placeholder="Last Name"
            />
          </FormGroup>
          <FormGroup widths="equal">
            <FormField
              label={<label style={{ color: '#702963' }}>Email</label>}
              control="input"
              id="email"
              name="email"
              maxLength="80"
              placeholder="Email"
            />
            <FormField
              label={<label style={{ color: '#702963' }}>Company</label>}
              control="input"
              id="company"
              name="company"
              maxLength="40"
              placeholder="Company"
            />
          </FormGroup>

          <FormGroup widths="equal">
            <FormField
              label={<label style={{ color: '#702963' }}>Title</label>}
              control="input"
              id="title"
              name="title"
              maxLength="40"
              placeholder="Title"
            />
            <FormField
              label={<label style={{ color: '#702963' }}>Phone</label>}
              control="input"
              id="phone"
              name="phone"
              maxLength="40"
              placeholder="Phone"
            />
          </FormGroup>

          <Accordion styled>
            <Accordion.Title
              active={activeIndex === 0}
              index={0}
              onClick={handleAccordionClick}
            >
              <Icon name="dropdown" />
              Optional Details
            </Accordion.Title>
            <Accordion.Content active={activeIndex === 0}>
              <FormGroup widths="equal">
                <FormField
                  label={<label style={{ color: '#702963' }}>Street</label>}
                  control="textarea"
                  id="street"
                  name="street"
                  placeholder="Street"
                />
                <FormField
                  label={<label style={{ color: '#702963' }}>City</label>}
                  control="input"
                  id="city"
                  name="city"
                  maxLength="40"
                  placeholder="City"
                />
              </FormGroup>

              <FormGroup widths="equal">
                <FormField
                  label={<label style={{ color: '#702963' }}>State/Province</label>}
                  control="input"
                  id="state"
                  name="state"
                  maxLength="20"
                  placeholder="State/Province"
                />
                <FormField
                  label={<label style={{ color: '#702963' }}>Zip</label>}
                  control="input"
                  id="zip"
                  name="zip"
                  maxLength="20"
                  placeholder="Zip"
                />
              </FormGroup>

              <FormGroup widths="equal">
                <FormField
                  label={<label style={{ color: '#702963' }}>Country</label>}
                  control="input"
                  id="country"
                  name="country"
                  maxLength="40"
                  placeholder="Country"
                />
                <FormField
                  label={<label style={{ color: '#702963' }}>Website</label>}
                  control="input"
                  id="url"
                  name="url"
                  maxLength="80"
                  placeholder="Website"
                />
              </FormGroup>

              <FormGroup widths="equal">
                <FormField
                  label={<label style={{ color: '#702963' }}>Description</label>}
                  control="textarea"
                  id="description"
                  name="description"
                  placeholder="Description"
                />
              </FormGroup>
            </Accordion.Content>
          </Accordion>

          <div className="g-recaptcha" data-sitekey="6Lfx3JcsAAAAAO5CwTDAM6e8z7ogfM_Rf5Tm6GFm"></div>
          <br />
          <Button type="submit" style={{ backgroundColor: '#702963', color: '#a9885c' }}>
            Submit
          </Button>
          <Divider hidden />
        </Form>
      </div>

      {/* Contact Buttons Section */}
      <div style={{ minWidth: '200px', display: 'flex', flexDirection: 'column', gap: '10px', justifyContent: 'center' }}>
        <Button
          as="a"
          href="mailto:cloudcaesar.registrar384@passmail.com"
          style={{ backgroundColor: '#702963', color: '#a9885c' }}
          icon
          labelPosition="left"
        >
          <Icon name="mail" />
          Email
        </Button>
        <Button
          as="a"
          href="tel:3215414991"
          style={{ backgroundColor: '#702963', color: '#a9885c' }}
          icon
          labelPosition="left"
        >
          <Icon name="phone" />
          Phone
        </Button>
        <Button
          as="a"
          href="https://t.me/CloudCaesar"
          target="_blank"
          style={{ backgroundColor: '#702963', color: '#a9885c' }}
          icon
          labelPosition="left"
        >
          <Icon name="telegram" />
          Telegram
        </Button>
        <Button
          as="a"
          href="https://www.linkedin.com/in/william-hawkins-914256268"
          target="_blank"
          style={{ backgroundColor: '#702963', color: '#a9885c' }}
          icon
          labelPosition="left"
        >
          <Icon name="linkedin" />
          LinkedIn
        </Button>
        <Button
          as="a"
          href="https://github.com/CloudCaesar"
          target="_blank"
          style={{ backgroundColor: '#702963', color: '#a9885c' }}
          icon
          labelPosition="left"
        >
          <Icon name="github" />
          GitHub
        </Button>
        <a
          href="https://signal.me/#p/@CloudCaesar.66"
          target="_blank"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            border: '2px solid #702963',
            borderRadius: '4px',
            padding: '10px',
            backgroundColor: '#fff',
            textDecoration: 'none',
            width: '100%',
            maxWidth: '150px',
            boxSizing: 'border-box',
          }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/assets/cloudcaesarsignal.png`}
            alt="Cloud CZR, Cloudczr, cloudczr.com"
            style={{
              width: '100%',
              height: 'auto',
              maxWidth: '130px',
            }}
          />
        </a>
      </div>
    </Container>
  );
};

export default WebToLead;